export const NETWORK_ERROR = 'NETWORK_ERROR';
export const CLEAR_NETWORK_ERROR = 'CLEAR_NETWORK_ERROR';
export const USER_NOT_FOUND_ERROR = 'USER_NOT_FOUND_ERROR';
export const VWGOA_SERVER_ERROR_GET_REQUEST_STATUS = 'VWGOA_SERVER_ERROR_GET_REQUEST_STATUS';
export const VWGOA_USER_NOT_FOUND_ERROR = 'VWGOA_USER_NOT_FOUND_ERROR';